import * as React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Category, Shop} from 'interfaces';
import {
  Hero,
  SocialProof,
  WhyExchange,
  HowExchange,
  InfoBar,
  ListingLayout,
  Support,
  SubscriptionLayout,
  CategoryCardLayout,
} from 'components/Marketplace';
import {Breadcrumb} from 'components/UIKit';
import styles from '../Location.scss';
import {fallbackSubscriptionPictureData} from '../images';
import {heroPictureData} from './images';
import * as locales from './locales';

export interface LocationsProps {
  authenticityToken: string;
  breadcrumbs: Breadcrumb[];
  shopsPath: string;
  countries: Category[];
  soldListings: Shop[];
  soldListingsPath: string;
  createAListingPath: string;
}

function LocationsComponent(props: LocationsProps & WithI18nProps) {
  const {
    authenticityToken,
    breadcrumbs,
    shopsPath,
    countries,
    soldListings = [],
    soldListingsPath,
    i18n,
  } = props;

  const showSoldListings = Boolean(soldListings.length);

  return (
    <>
      <InfoBar breadcrumbs={breadcrumbs} />
      <Hero
        heading={i18n.translate('heading')}
        subhead={i18n.translate('subhead')}
        cta={i18n.translate('cta')}
        url={shopsPath}
        pictureData={heroPictureData}
      />
      <CategoryCardLayout
        heading={i18n.translate('allCountries.heading')}
        subhead={i18n.translate('allCountries.subhead')}
        categories={countries}
        className={styles.BackgroundSilverLight}
      />
      <SubscriptionLayout
        authenticityToken={authenticityToken}
        fallbackPictureData={fallbackSubscriptionPictureData}
      />
      <WhyExchange />
      {showSoldListings && (
        <ListingLayout
          heading={i18n.translate('soldListings.heading')}
          subhead={i18n.translate('soldListings.subhead')}
          shops={soldListings || []}
          cta={i18n.translate('soldListings.cta')}
          ctaPath={soldListingsPath}
          className={styles.BackgroundSilverLight}
        />
      )}
      <SocialProof ctaPath={shopsPath} />
      <HowExchange />
      <Support />
    </>
  );
}

export const Locations = withI18n({
  id: 'Locations',
  fallback: locales.en,
})(LocationsComponent);
